import { stopLoad } from 'src/helper/webviewFun'
import React from 'react'
import { store, Provider, debug } from 'src/core/store'
import { RouteComponent } from 'src/core/router'
import 'react-vant/es/styles';
// import { initializeApp } from "firebase/app";
import config from 'src/core/config'
import VConsole from 'src/helper/vconsole'
import localstorage from 'src/helper/localstorage'
// Import the functions you need from the SDKs you need

const firebaseConfig = {
  apiKey: "AIzaSyAUaujr08hNvmlxRJCSJ3KPgzV1dyIbQeg",
  authDomain: "chatie-ec097.firebaseapp.com",
  projectId: "chatie-ec097",
  storageBucket: "chatie-ec097.appspot.com",
  messagingSenderId: "500262600030",
  appId: "1:500262600030:web:a8bdb54d3bc8f56903e3cf",
  measurementId: "G-EKTG3GW58R"
};

// Initialize Firebase
const logEventMain = (type) => {
  /* 埋点要全局去除 */
}

React.Component.prototype.$logEvent = logEventMain;


stopLoad()
const isProd = ['vocaProd', 'production'].includes(process.env.NODE_ENV)
const isUat = ['uat', 'vocaUat'].includes(process.env.NODE_ENV)

// 注册全局store
export default class App extends React.Component {
  constructor() {
    super()
  }
  componentDidMount(){
    if (!isProd && !isUat) {
      new VConsole()
    }
    localStorage.setItem('loglevel:webpack-dev-server','SILENT')
    localstorage.remove('cb')
  }
  componentWillUnmount(){
    localstorage.remove('isRuby')
    localstorage.remove('paypalType')
    localStorage.removeItem('loglevel:webpack-dev-server')
    localstorage.remove('thHostGuidId')
    localstorage.remove('hostGuidIdInfo')
  }
  render() {
    debug()
    return (
      <Provider store={store}>
        <RouteComponent />
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// src/core/app.js